import * as trackerConstants from "./constants";

export function trackEvent(eventName, eventProperties) {
    return dispatch => {
        dispatch({
            type: trackerConstants.TRACKED_EVENT_TRIGGERED,
            tracker: {
                eventName,
                eventProperties
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/modules/tracker/actions.js